import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';

export function Footer() {
  return (
    <footer data-testid="public-footer" className="mt-16 border-t border-kelate-line bg-kelate-surface pb-20 md:pb-0">
      <div className="mx-auto grid max-w-[1280px] gap-8 px-4 py-12 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <Logo className="h-7" testId="footer-logo" />
          <p className="mt-2 text-sm text-kelate-soft">Discover Local. Shop Local. Grow Local.</p>
          <p className="mt-1 text-xs text-kelate-soft">A Kelantan-first marketplace connecting local brands, merchants and communities.</p>
        </div>
        <div>
          <h4 className="text-sm font-semibold text-kelate-ink">Shop</h4>
          <ul className="mt-2 space-y-1.5 text-sm text-kelate-soft">
            <li><Link to="/marketplace" className="hover:text-kelate-wood">Marketplace</Link></li>
            <li><Link to="/promotions" className="hover:text-kelate-wood">Promotions</Link></li>
            <li><Link to="/made-in-kelantan" className="hover:text-kelate-wood">Made in Kelantan</Link></li>
            <li><Link to="/explore" className="hover:text-kelate-wood">Explore Kelantan</Link></li>
            <li><Link to="/partners" className="hover:text-kelate-wood">Collaboration Partners</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-semibold text-kelate-ink">Sell with us</h4>
          <ul className="mt-2 space-y-1.5 text-sm text-kelate-soft">
            <li><Link to="/merchant/register" className="hover:text-kelate-wood">Become a Merchant</Link></li>
            <li><Link to="/merchant/register" className="hover:text-kelate-wood">Plans from RM10/month</Link></li>
            <li><Link to="/account/login" className="hover:text-kelate-wood">Merchant Center</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-semibold text-kelate-ink">KELATE Delivery</h4>
          <p className="mt-2 text-sm text-kelate-soft">Pay on delivery — Cash, TNG QR or Bank Transfer when your order arrives.</p>
          <p className="mt-2 text-xs text-kelate-soft">Kota Bharu local RM3 · Kelantan RM5 · Outside RM10</p>
        </div>
      </div>
      <div className="border-t border-kelate-line py-4 text-center text-xs text-kelate-soft">
        © 2026 KELATE · Kota Bharu, Kelantan
      </div>
    </footer>
  );
}
